@use 'src/globals/main';

pn-button-dropdown {
  display: inline-block;
  position: relative;
}
pn-button-dropdown .pn-button-dropdown {
  &-container {
    position: absolute;
    top: 130%;
    left: 0;
    border-radius: 1em;
    box-shadow: 0 0.125em 1em rgba(0, 0, 0, 0.2);
    transform-origin: top left;
    transition: transform main.$timing main.$easing 0.15s;
    transform: scale(0);
    overflow-y: auto;
    max-width: 95vw;
    max-width: min(95vw, 40em);
    max-height: 80vh;
    z-index: 10;
    background: main.$white;
    &[data-right] {
      left: unset;
      right: 0;
      transform-origin: top right;
    }

    &[data-top] {
      top: unset;
      bottom: 130%;
      transform-origin: bottom left;
    }
  }

  &-content {
    padding: 1em;
    opacity: 0;
    transition:
      opacity main.$timing main.$easing,
      visibility 0.2s;
    transition-delay: 0s;
    position: relative;
    width: max-content;
    max-width: 100%;
    visibility: hidden;
  }

  &[data-open='true'] {
    .pn-button-dropdown-container {
      transition-delay: 0s;
    }
    .pn-button-dropdown-content {
      opacity: 1;
      visibility: visible;
    }
  }
}
